var alignmentStyle = {"alignLeft":"_2PZFW","textWrapNowrap":"_-9UUi","alignRight":"GjArn","alignCenter":"Si66Q","sizeFullWidth":"KGro6","renderedInTable":"ofuSx","sizeOriginal":"DOdCl","sizeContent":"K92k8","sizeSmall":"aTqla","sizeSmallCenter":"rHdsw","flex":"Kb-Yh","LEFT":"-xZP5","CENTER":"-bt26","RIGHT":"_-9UvG","AUTO":"_8UBmS","JUSTIFY":"WZ-z2"};

export { alignmentStyle as a };
//# sourceMappingURL=alignment.rtlignore-64bd143d.js.map
